import { EventRecordExtraDetails } from "@/store/site-monitor/types";

export const eventRecordMixins = {
	methods: {
		getParsedExtraDetails(extraDetailsJson: string): EventRecordExtraDetails {
			if (!extraDetailsJson) {
				return {
					data: [],
					hasParsingError: false
				};
			}

			try {
				const parsedData = JSON.parse(extraDetailsJson);

				if (
					parsedData.length > 0 && parsedData.every(obj => JSON.stringify(obj) === "{}")
					|| parsedData.some(obj => Object.keys(obj).length > 1)
				) {
					return {
						data: undefined,
						hasParsingError: true
					};
				}

				if (Array.isArray(parsedData)) {
					return {
						data: parsedData,
						hasParsingError: false
					};
				} else {
					return {
						data: undefined,
						hasParsingError: true
					};
				}
			}
			catch {
				const failure: EventRecordExtraDetails =
					{
						data: undefined,
						hasParsingError: true
					};
				return failure;
			}
		},
		isExtraDetailsValid(extraDetailsJson: string): boolean {
			if (!extraDetailsJson) {
				return false;
			}

			try {
				const parsedJson = JSON.parse(extraDetailsJson);
				return Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson.every(obj => Object.keys(obj).length <= 1);
			}
			catch {
				return false;
			}
		},
	}
}
